import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useActivityQuizzesForSelector = (courseId?: string) => {
  const { isLoading, data } = useQuery({
    queryKey: ['quizzes', 'activity', courseId],
    queryFn: () => QuizService.getActivityQuizzesForSelector(courseId!),
    enabled: !!courseId
  });

  return {
    quizzes: data,
    isLoading
  };
};
